var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearch01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.2 11.158a7.958 7.958 0 1 1 15.916 0 7.958 7.958 0 0 1-15.916 0M11.158 4.8a6.358 6.358 0 1 0 0 12.716 6.358 6.358 0 0 0 0-12.716"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.435 21.566-4.474-4.474 1.131-1.131 4.474 4.474z"
}))));
export default SvgIconSearch01;